<div class="container-fluid">
  @if (currentTimeColumn === 'Contribution Finish') {
    <p style="text-align: right; margin: 0px;">
      <b>{{ 'Assess.lblTimeToClose' | translate }}</b>
    </p>
  }
  @if (currentTimeColumn === 'Contribution Start') {
    <p style="text-align: right; margin: 0px;">
      <b>{{ 'Assess.lblTimeToOpen' | translate }}</b>
    </p>
  }
  <p style="text-align: right; margin: 0px;">
    {{ timeToOpenOrClose }}
  </p>
  <h4>
    {{ assessMarket.marketCode }} {{ 'Assess.header' | translate }}
  </h4>
  <mat-tab-group dynamicHeight mat-align-tabs="start" mat-stretch-tabs="false" selectedIndex="{{ showTransaction() && showSubmission() == false ? '1': '0' }}" animationDuration="1000ms" class="{{ showTransaction() && showSubmission()? '' : ' hideTabs' }}">
    <mat-tab label="{{ 'Assess.lblSubmissions' | translate }}" [ngStyle]="{'display': showSubmission() === true ? 'inline' : 'none' }">
      <app-contribution-summary (getTransactions)="GetTransactions()" (getContributions)="GetContributions()" (checkOverrideWindow)="CheckWindowOverride('submission'); CheckWindowOverride('transaction')"></app-contribution-summary>
      @if (showSubmission()) {
        <div [@slider]="showSubmission() ? 'show' : null" class="slider">
          <div id="assessTable" class="mat-elevation-z6 mt-3">
            <form>
              <table mat-table [dataSource]="dataSourceNew">
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef style="width: 10%; font-size: 16px;">
                    {{ 'Assess.thTenor' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" [style.color]="element.notes.trim() !== '' ? (element.instrumentAccepted ? 'green' : 'red') : ''">
                    {{ element.instrumentDescription }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="assessedRate">
                  <th mat-header-cell *matHeaderCellDef style="width: 10%; font-size: 16px;">
                    {{ 'Assess.thAssessedRate' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-label [style.color]="element.notes.trim() !== '' ? (element.instrumentAccepted ? 'green' : 'red') : ''" matTooltip="{{ element.notes }}">
                      {{ element.assessedRate }}
                    </mat-label>
                  </td>
                </ng-container>
                <ng-container matColumnDef="level">
                  <th mat-header-cell *matHeaderCellDef style="width: 5%;">
                    {{ 'Assess.thLevel' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" [style.color]="element.notes.trim() !== '' ? (element.instrumentAccepted ? 'green' : 'red') : ''">
                    {{ element.level }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="newRate">
                  <th mat-header-cell *matHeaderCellDef style="width: 5%;">
                    {{ 'Assess.thCOF' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-label class="{{ (element.rate !== element.lastRate) && element.lastRate ? 'hasChangedClass' : (element.notes.trim() !== '' ? (element.instrumentAccepted ? 'hasAccepted' : 'hasRejected') : '') }}" matTooltip="{{ (element.rate !== element.lastRate) ? element.lastRate : '' }}">
                      {{ element.rate }}
                    </mat-label>
                  </td>
                </ng-container>
                <ng-container matColumnDef="defaultSpread">
                  <th mat-header-cell *matHeaderCellDef style="width: 10%;">
                    {{ 'Assess.thDefaultSpread' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-label class="{{ (element.lastSpread !== element.spread) && element.lastSpread ? 'hasChangedClass' : (element.notes.trim() !== '' ? (element.instrumentAccepted ? 'hasAccepted' : 'hasRejected') : '') }}" matTooltip="{{ element.lastSpread }}">
                      {{ element.defaultSpread }}
                    </mat-label>
                  </td>
                </ng-container>
                <ng-container matColumnDef="newSpread">
                  <th mat-header-cell *matHeaderCellDef style="width: 5%;">
                    {{ 'Assess.thNewSpread' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-label class="{{ (element.lastSpread !== element.spread) && element.lastSpread ? 'hasChangedClass' : (element.notes.trim() !== '' ? (element.instrumentAccepted ? 'hasAccepted' : 'hasRejected') : '') }}" matTooltip="{{ (element.lastSpread !== element.spread) ? element.lastSpread : '' }}">
                      {{ element.spread }}
                    </mat-label>
                  </td>
                </ng-container>
                <ng-container matColumnDef="fsaCOF">
                  <th mat-header-cell *matHeaderCellDef style="width: 5%;">
                    {{ 'Assess.thFSACOF' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" [style.color]="element.notes.trim() !== '' ? (element.instrumentAccepted ? 'green' : 'red') : ''">
                    {{ element.fsaCOF }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="comments">
                  <th mat-header-cell *matHeaderCellDef style="font-size: 16px;">
                    {{ 'Assess.thComments' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" [style.color]="element.notes.trim() !== '' ? (element.instrumentAccepted ? 'green' : 'red') : ''">
                    {{ element.comments }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="notes">
                  <th mat-header-cell *matHeaderCellDef style="width: 30%; font-size: 16px;">
                    {{ 'Assess.thNotes' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <input (focusout)="OnClickAction()" class="tableInput {{ (element.accepted === 'false') && (!element.newNotes) ? 'hasError' : '' }}" matInput type="text" [(ngModel)]="element.newNotes" [ngModelOptions]="{standalone: true}" />
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef style="width: 10%;"></th>
                  <td mat-cell *matCellDef="let element">
                    <div style="text-align: center;">
                      <mat-button-toggle-group [(ngModel)]="element.accepted" [ngModelOptions]="{standalone: true}" style="height: 30px; align-items: center;" (change)="OnClickAction()" [disabled]="!assessMarket.canAssess">
                        <mat-button-toggle value="true"><i style="font-size: 1em;" class="fa fa-check text-success" aria-hidden="true"></i></mat-button-toggle>
                        <mat-button-toggle value="null"><i style="font-size: 1em;" class="fa fa-question" aria-hidden="true"></i></mat-button-toggle>
                        <mat-button-toggle value="false"><i style="font-size: 1em;" class="fa fa-times text-danger" aria-hidden="true"></i></mat-button-toggle>
                      </mat-button-toggle-group>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="loading">
                  <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">
                    {{ 'tblLoading' | translate }}...
                  </th>
                </ng-container>
                <ng-container matColumnDef="noData">
                  <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">
                    {{ 'Assess.tblNoData' | translate }}...
                  </th>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayColumns;" matTooltip="{{ row.notes }}"></tr>
                <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':dataSourceNew!=null}"></tr>
                <tr mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide':dataSourceNew!=null && instrumentLength != 0}"></tr>
              </table>
            </form>
          </div>
          @if (instrumentLength > 0 && service.currentUser.isReadOnly === false) {
            <div style="margin: 10px;">
              <button [disabled]="!canEnableSubmit || !assessMarket.canAssess" mat-raised-button style="float: right; margin-left: 10px;" color="primary" type="button" (click)="OnSubmitClick()">
                {{ 'btnSubmit' | translate }}
              </button>
            </div>
          }
        </div>
      }
    </mat-tab>
    <mat-tab label="{{ 'Assess.lblTransactions' | translate }}" [ngStyle]="{'display': showTransaction() === true ? 'inline' : 'none' }">
      <div [@slider]="showTransaction()? 'show' : null">
        <div class="scrollableTable mat-elevation-z8" style="overflow: auto;">
          <table mat-table [dataSource]="dataSourceTrans">
            <ng-container matColumnDef="contributed">
              <th mat-header-cell *matHeaderCellDef style="min-width: 5%;">
                {{ 'Assess.thContributed' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" style="white-space: nowrap">
                {{ element.contributed | date:"h:mm:ss a" }}
              </td>
            </ng-container>
            <ng-container matColumnDef="currency">
              <th mat-header-cell *matHeaderCellDef style="min-width: 5%;">
                {{ 'Assess.thCurrency' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{ checkTradeColumn(element, 'currency', true) }}" class="{{ checkTradeColumn(element, 'currency') == 'true' ? 'hasChangedClass' : '' }}">
                {{ element.currency.value }}
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef style="min-width: 5%;">
                {{ 'Assess.thStatus' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{ checkTradeColumn(element, 'status', true) }}" class="{{ checkTradeColumn(element, 'status') == 'true' ? 'hasChangedClass' : '' }}">
                {{ element.status }}
              </td>
            </ng-container>
            <ng-container matColumnDef="cpSector">
              <th mat-header-cell *matHeaderCellDef style="min-width: 5%;">
                {{ 'Assess.thCpSector' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{ checkTradeColumn(element, 'counterParty', true) }}" class="{{ checkTradeColumn(element, 'counterParty') == 'true' ? 'hasChangedClass' : '' }}">
                {{ element.counterParty }}
              </td>
            </ng-container>
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef style="min-width: 5%;">
                {{ 'Assess.thType' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{ checkTradeColumn(element, 'type', true) }}" class="{{ checkTradeColumn(element, 'type') == 'true' ? 'hasChangedClass' : '' }}">
                {{ element.type }}
              </td>
            </ng-container>
            <ng-container matColumnDef="instrumentType">
              <th mat-header-cell *matHeaderCellDef style="min-width: 5%;">
                {{ 'Assess.thInstrumentType' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{ checkTradeColumn(element, 'instrumentType', true) }}" class="{{ checkTradeColumn(element, 'instrumentType') == 'true' ? 'hasChangedClass' : '' }}">
                {{ element.instrumentType }}
              </td>
            </ng-container>
            <ng-container matColumnDef="identifier">
              <th mat-header-cell *matHeaderCellDef style="min-width: 5%;">
                {{ 'Assess.thIdentifier' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{ checkTradeColumn(element, 'identifier', true) }}" class="{{ checkTradeColumn(element, 'identifier') == 'true' ? 'hasChangedClass' : '' }}" style="white-space: nowrap">
                {{ element.identifier }}
              </td>
            </ng-container>
            <ng-container matColumnDef="tradeDate">
              <th mat-header-cell *matHeaderCellDef style="min-width: 100px;">
                {{ 'Assess.thTradeDate' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{ checkTradeColumn(element, 'tradeDate', true) }}" class="{{ checkTradeColumn(element, 'tradeDate') == 'true' ? 'hasChangedClass' : '' }}">
                {{ element.tradeDate | date:"d MMM yyyy" }}
              </td>
            </ng-container>
            <ng-container matColumnDef="settlementDate">
              <th mat-header-cell *matHeaderCellDef style="min-width: 5%;">
                {{ 'Assess.thSettlementDate' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{ checkTradeColumn(element, 'settlementDate', true) }}" class="{{ checkTradeColumn(element, 'settlementDate') == 'true' ? 'hasChangedClass' : '' }}">
                {{ element.settlementDate | date:"d MMM yyyy" }}
              </td>
            </ng-container>
            <ng-container matColumnDef="maturityDate">
              <th mat-header-cell *matHeaderCellDef style="min-width: 5%;">
                {{ 'Assess.thMaturityDate' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{ checkTradeColumn(element, 'maturityDate', true) }}" class="{{ checkTradeColumn(element, 'maturityDate') == 'true' ? 'hasChangedClass' : '' }}">
                {{ element.maturityDate | date:"d MMM yyyy" }}
              </td>
            </ng-container>
            <ng-container matColumnDef="nominalAmount">
              <th mat-header-cell *matHeaderCellDef style="min-width: 5%;">
                {{ 'Assess.thNomAmount' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{ checkTradeColumn(element, 'nominalAmount', true) }}" class="{{ checkTradeColumn(element, 'nominalAmount') == 'true' ? 'hasChangedClass' : '' }}">
                {{ FormatNumber(element.nominalAmount) }}
              </td>
            </ng-container>
            <ng-container matColumnDef="rate">
              <th mat-header-cell *matHeaderCellDef style="min-width: 5%;">
                {{ 'Assess.thRate' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{ checkTradeColumn(element, 'rate', true) }}" class="{{ checkTradeColumn(element, 'rate') == 'true' ? 'hasChangedClass' : '' }}">
                {{ element.rate }}
              </td>
            </ng-container>
            <ng-container matColumnDef="comments">
              <th mat-header-cell *matHeaderCellDef style="font-size: 16px;">
                {{ 'Assess.thComments' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" matTooltip="{{ checkTradeColumn(element, 'comments', true) }}" class="{{ checkTradeColumn(element, 'comments') == 'true' ? 'hasChangedClass' : '' }}">
                {{ element.comments }}
              </td>
            </ng-container>
            <ng-container matColumnDef="notes">
              <th mat-header-cell *matHeaderCellDef style="width: 30%; font-size: 16px;">
                {{ 'Assess.thNotes' | translate }}
              </th>
              <td mat-cell *matCellDef="let element">
                <input matInput type="text" [(ngModel)]="element.newNotes" style="width: 300px" class="tableInput {{ (element.accepted === 'false') && (!element.newNotes) ? 'hasError' : '' }}" [ngModelOptions]="{standalone: true}" (focusout)="OnClickActionTransaction()" />
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef style="width: 10%;" class="stickyRightHeader">{{ 'thActions' | translate }}</th>
              <td mat-cell *matCellDef="let element" class="stickyRightColumn">
                <div style="text-align: center;">
                  <mat-button-toggle-group [(ngModel)]="element.accepted" [ngModelOptions]="{standalone: true}" style="height: 30px; align-items: center;" (change)="OnClickActionTransaction()" [disabled]="!assessTrans.canAssess">
                    <mat-button-toggle value="true"><i style="font-size: 1em;" class="fa fa-check text-success" aria-hidden="true"></i></mat-button-toggle>
                    <mat-button-toggle value="null"><i style="font-size: 1em;" class="fa fa-question" aria-hidden="true"></i></mat-button-toggle>
                    <mat-button-toggle value="false"><i style="font-size: 1em;" class="fa fa-times text-danger" aria-hidden="true"></i></mat-button-toggle>
                  </mat-button-toggle-group>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="loading">
              <th class="loading" mat-footer-cell *matFooterCellDef colspan="16">
                {{ 'tblLoading' | translate }}...
              </th>
            </ng-container>
            <ng-container matColumnDef="noData">
              <th class="loading" mat-footer-cell *matFooterCellDef colspan="16">
                {{ 'Assess.tblNoData' | translate }}...
              </th>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayColumnsTrans; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumnsTrans;" matTooltip="{{ row.notes }}"></tr>
            <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':dataSourceTrans!=null}"></tr>
            <tr mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide':(dataSourceTrans!=null && transRecordsLength != 0) || isLoading === true}"></tr>
          </table>
        </div>
        @if (service.currentUser.isReadOnly === false) {
          <div style="margin: 10px;">
            <button [disabled]="!canEnableTransSubmit || !assessTrans.canAssess" mat-raised-button style="float: right; margin-left: 10px;" color="primary" type="button" (click)="OnSubmitTransClick()">
              {{ 'btnSubmit' | translate }}
            </button>
          </div>
        }
      </div>
    </mat-tab>
  </mat-tab-group>
  @if (assessMarket.isMarketOpen === false && assessMarket.isAllowedUser === true) {
    <div [@slider]="assessMarket.isMarketOpen === false && assessMarket.isAllowedUser === true? 'show' : null" class="slider">
      <p>
        {{ 'Assess.notReady' | translate }}
      </p>
    </div>
  }
  @if (assessMarket.isAllowedUser === false  && isLoading === false) {
    <div [@slider]="assessMarket.isAllowedUser === false  && isLoading === false? 'show' : null" class="slider">
      <p>
        {{ 'Assess.notAllowed' | translate }}
      </p>
    </div>
  }
  @if (isLoading === true) {
    <div [@slider]="isLoading === true? 'show' : null" class="slider">
      <p>
        {{ 'tblLoading' | translate }}...
      </p>
    </div>
  }
</div>
